import { Loader as MantineLoader } from "@mantine/core"

export const Loader = MantineLoader.extend({
  defaultProps: {
    type: "dots",
  },
})
